import axiosInstance from "../../axios/axiosInstance";
import { DASHBOARD_APIS, SALES_DETAILS_LISTING, SALES_PRICE_DETAILS_LISTING, TOTAL_ORDER_DETAILS_LISTING } from "../../constants";

export const getDashboardApis = () => onResponse => {
  try {
    axiosInstance.get(DASHBOARD_APIS)
      .then((response) => {
        // console.log(response)
        onResponse(response.data);
      })
      .catch((err) => {
        console.log(err)
        onResponse(err);
      });

  } catch (error) {

  }

};

export const getSalesDetails = (payload) => onResponse => {

  try {
    axiosInstance.post(SALES_DETAILS_LISTING, payload)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });

  } catch (error) {

  }
};


export const getSalesPriceDetails = (payload) => (onResponse) => {
  try {
    axiosInstance
      .post(SALES_PRICE_DETAILS_LISTING, payload)
      .then((response) => {
        onResponse(response);
      })
      .catch((err) => {
        onResponse(err.response);
      });
  } catch (error) {
    console.error('API call failed:', error);
  }
};


export const getTotalOrderCount = (props) => (onResponse) => {
    try {
        // e.g., "/api/orders/totalOrders"
        axiosInstance
            .post(TOTAL_ORDER_DETAILS_LISTING, props)
            .then((response) => {
                onResponse(response.data);
            })
            .catch((err) => {
                onResponse(err);
            });
    } catch (error) { }
};